import React, { useState } from 'react';
import styled from 'styled-components';
import config from '../config';

const DebugContainer = styled.div`
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f8f8f8;
  font-family: monospace;
  font-size: 0.9rem;
`;

const DebugHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const DebugTitle = styled.h4`
  margin: 0;
  color: #333;
`;

const DebugButton = styled.button`
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 0.8rem;
  
  &:hover {
    background-color: #e9e9e9;
  }
`;

const DebugContent = styled.div`
  margin-top: 10px;
`;

const DebugItem = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
`;

const DebugLabel = styled.span`
  font-weight: bold;
  margin-right: 10px;
  color: #555;
`;

const DebugValue = styled.span`
  font-family: monospace;
  word-break: break-all;
`;

const ApiKeyDebug = () => {
  const [showDebug, setShowDebug] = useState(false);
  
  const toggleDebug = () => {
    setShowDebug(!showDebug);
  };
  
  // Check if any API key variables are defined
  const hasReactEnvKey = !!process.env.REACT_APP_OPENAI_API_KEY;
  const hasWindowKey = typeof window !== 'undefined' && !!window.OPENAI_API_KEY;
  const hasConfigKey = !!config.openai?.apiKey;
  const hasPlainEnvKey = !!process.env.OPENAI_API_KEY;
  
  // Generate a masked version of the key for display
  const maskApiKey = (key) => {
    if (!key) return 'Not defined';
    if (typeof key !== 'string') return 'Invalid format';
    if (key.length < 8) return '***' + key.slice(-3);
    return key.slice(0, 3) + '...' + key.slice(-4);
  };
  
  return (
    <DebugContainer>
      <DebugHeader>
        <DebugTitle>OpenAI API Key Diagnostics</DebugTitle>
        <DebugButton onClick={toggleDebug}>
          {showDebug ? 'Hide Details' : 'Show Details'}
        </DebugButton>
      </DebugHeader>
      
      {showDebug && (
        <DebugContent>
          <DebugItem>
            <DebugLabel>Config has API Key:</DebugLabel>
            <DebugValue>{hasConfigKey ? '✅ Yes' : '❌ No'}</DebugValue>
          </DebugItem>
          
          <DebugItem>
            <DebugLabel>Config API Key:</DebugLabel>
            <DebugValue>
              {config.openai?.apiKey ? 
                maskApiKey(config.openai.apiKey) : 
                'Not defined'}
            </DebugValue>
          </DebugItem>
          
          <DebugItem>
            <DebugLabel>REACT_APP_OPENAI_API_KEY:</DebugLabel>
            <DebugValue>{hasReactEnvKey ? '✅ Defined' : '❌ Not defined'}</DebugValue>
          </DebugItem>
          
          <DebugItem>
            <DebugLabel>window.OPENAI_API_KEY:</DebugLabel>
            <DebugValue>{hasWindowKey ? '✅ Defined' : '❌ Not defined'}</DebugValue>
          </DebugItem>
          
          <DebugItem>
            <DebugLabel>Environment:</DebugLabel>
            <DebugValue>
              {process.env.NODE_ENV || 'Not defined'}
            </DebugValue>
          </DebugItem>
          
          <DebugItem>
            <DebugLabel>Browser:</DebugLabel>
            <DebugValue>
              {typeof navigator !== 'undefined' ? navigator.userAgent : 'Not available'}
            </DebugValue>
          </DebugItem>
        </DebugContent>
      )}
    </DebugContainer>
  );
};

export default ApiKeyDebug; 